import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export const cssGlow = css`
  border-radius: 4px;
  animation: glow 0.75s infinite alternate;

  @keyframes glow {
    from {
      box-shadow: 0 0 5px -5px ${colors.yellow03};
    }
    to {
      box-shadow: 0 0 5px 15px ${colors.yellow03};
      background-color: ${colors.yellow03};
    }
  }
`

const cssLink = css`
  list-style: none;
  padding: 0 12px;
  margin: 0 -12px;
`

export const cssNonClickableLink = css`
  ${cssLink}
  cursor: default;
`

export const cssClickableLink = css`
  ${cssLink}
  ${cssGlow}
`

export const cssDropDownMenu = css`
  width: 262px;
`
